import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ContentBlock, ElidedBlock, InterRegionPaddingBlock } from '@jbrowse/core/util/blockTypes';
import { observer } from 'mobx-react';
import React from 'react';
import { ContentBlock as ContentBlockComponent, ElidedBlock as ElidedBlockComponent, InterRegionPaddingBlock as InterRegionPaddingBlockComponent } from '../../BaseLinearDisplay/components/Block';
import { makeTicks } from '../util';
import { getTickDisplayStr } from '@jbrowse/core/util';
var useStyles = makeStyles()(function (theme) {
  return {
    scalebarContainer: {
      overflow: 'hidden',
      position: 'relative'
    },
    scalebarZoomContainer: {
      position: 'relative',
      zIndex: 1
    },
    scalebar: {
      position: 'absolute',
      display: 'flex',
      pointerEvents: 'none'
    },
    majorTickLabel: {
      fontSize: '11px',
      zIndex: 1,
      background: theme.palette.background.paper,
      lineHeight: 'normal',
      pointerEvents: 'none'
    },
    tick: {
      position: 'absolute',
      width: 0,
      display: 'flex',
      justifyContent: 'center',
      pointerEvents: 'none'
    },
    refLabel: {
      fontSize: '11px',
      position: 'absolute',
      left: '2px',
      top: '-1px',
      fontWeight: 'bold',
      lineHeight: 'normal',
      zIndex: 1,
      pointerEvents: 'none',
      background: theme.palette.background.paper
    }
  };
});
var RenderedRefNameLabels = observer(function (_ref) {
  var model = _ref.model;
  var _useStyles = useStyles(),
    classes = _useStyles.classes; // find the block that needs pinning to the left side for context
  var lastLeftBlock = 0;
  model.staticBlocks.forEach(function (block, i) {
    if (block.offsetPx - model.offsetPx < 0) {
      lastLeftBlock = i;
    }
  });
  return React.createElement(React.Fragment, null, model.staticBlocks.map(function (block, index) {
    return block instanceof ContentBlock && (block.isLeftEndOfDisplayedRegion || index === lastLeftBlock) ? React.createElement(Typography, {
      key: "refLabel-".concat(block.key, "-").concat(index),
      style: {
        left: index === lastLeftBlock ? Math.max(0, -model.offsetPx) : block.offsetPx - model.offsetPx - 1,
        paddingLeft: index === lastLeftBlock ? 0 : 1
      },
      className: classes.refLabel,
      "data-testid": "refLabel-".concat(block.refName)
    }, block.refName) : null;
  }));
});
var RenderedScalebarLabels = observer(function (_ref2) {
  var model = _ref2.model;
  var _useStyles2 = useStyles(),
    classes = _useStyles2.classes;
  var bpPerPx = model.bpPerPx,
    staticBlocks = model.staticBlocks;
  return React.createElement(React.Fragment, null, staticBlocks.map(function (block, index) {
    var reversed = block.reversed,
      start = block.start,
      end = block.end,
      key = block.key,
      widthPx = block.widthPx;
    if (block instanceof ContentBlock) {
      var ticks = makeTicks(start, end, bpPerPx, true, false);
      return React.createElement(ContentBlockComponent, {
        key: "".concat(key, "-").concat(index),
        block: block
      }, ticks.map(function (tick) {
        if (tick.type === 'major') {
          var x = (reversed ? end - tick.base : tick.base - start) / bpPerPx;
          var baseNumber = tick.base + 1;
          return React.createElement("div", {
            key: tick.base,
            className: classes.tick,
            style: {
              left: x
            }
          }, baseNumber ? React.createElement(Typography, {
            className: classes.majorTickLabel
          }, getTickDisplayStr(baseNumber, bpPerPx)) : null);
        }
        return null;
      }));
    }
    if (block instanceof ElidedBlock) {
      return React.createElement(ElidedBlockComponent, {
        key: key,
        width: widthPx
      });
    }
    if (block instanceof InterRegionPaddingBlock) {
      return React.createElement(InterRegionPaddingBlockComponent, {
        key: key,
        width: widthPx,
        style: {
          background: 'none'
        },
        boundary: block.variant === 'boundary'
      });
    }
    return null;
  }));
});
var Scalebar = React.forwardRef(function (_ref3, ref) {
  var model = _ref3.model,
    style = _ref3.style,
    className = _ref3.className,
    other = _objectWithoutProperties(_ref3, ["model", "style", "className"]);
  var _useStyles3 = useStyles(),
    classes = _useStyles3.classes,
    cx = _useStyles3.cx;
  var offsetLeft = model.staticBlocks.offsetPx - model.offsetPx;
  return React.createElement(Paper, _objectSpread({
    "data-resizer": "true" // used to avoid click-and-drag scrolls on trackscontainer
    ,
    className: cx(classes.scalebarContainer, className),
    variant: "outlined",
    ref: ref,
    style: style
  }, other), React.createElement("div", {
    className: classes.scalebarZoomContainer,
    style: {
      transform: model.scaleFactor !== 1 ? "scaleX(".concat(model.scaleFactor, ")") : undefined
    }
  }, React.createElement("div", {
    className: classes.scalebar,
    style: _objectSpread({
      left: offsetLeft - 1,
      width: model.staticBlocks.totalWidthPx
    }, style)
  }, React.createElement(RenderedScalebarLabels, {
    model: model
  }))), React.createElement(RenderedRefNameLabels, {
    model: model
  }));
});
export default observer(Scalebar);